<script setup lang="ts"></script>

<template>
  <ContentBlock variant="white">
    <article class="space-y-6">
      <div class="flex flex-col gap-6 md:flex-row">
        <div class="flex-1 space-y-2">
          <div class="h-8 w-3/4 rounded bg-gray-300" />
          <div class="h-4 w-1/3 rounded bg-gray-300" />
        </div>
      </div>
      <hr class="w-full" />
      <div class="space-y-5">
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-3/4 rounded bg-gray-300" />
      </div>
      <div class="hidden h-48 w-72 rounded-md bg-gray-300 md:block" />
      <div class="space-y-5">
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-full rounded bg-gray-300 md:w-3/4" />
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-full rounded bg-gray-300 md:w-3/4" />
        <div class="h-4 w-full rounded bg-gray-300" />
        <div class="h-4 w-full rounded bg-gray-300 md:w-3/4" />
      </div>
      <div class="flex justify-between border-t pt-6 align-middle text-sm">
        <div class="h-4 w-40 rounded bg-gray-300" />
        <div class="h-4 w-16 rounded bg-gray-300" />
      </div>
    </article>
  </ContentBlock>
</template>
